import React, { Fragment, useState, useEffect, useRef } from "react";
import { NavLink, useHistory, withRouter, useLocation } from "react-router-dom";
import useStyles from "./style";
import ExitToAppIcon from "@material-ui/icons/ExitToApp";
import {
    AppBar,
    Toolbar,
    Typography,
    IconButton,
    Drawer,
    MenuList,
    MenuItem,
    ListItemText,
    Divider,
    Box,
    Collapse
} from "@material-ui/core";
import MenuIcon from "@material-ui/icons/Menu";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import { useSelector } from "react-redux";
import { MxUtils } from "../../utils/mxutils";
import { ExpandLess, ExpandMore, Home } from "@material-ui/icons";
import { useDispatch } from "react-redux";
import { MxAlertaActions } from "../../store/ducks/components/mxalerta/mxalerta";
import { VistoriaActions } from "../../store/ducks/application/CarregaDescarregaContainer/vistoria";
import { LacresActions } from "../../store/ducks/application/CarregaDescarregaContainer/lacre";
import { RemocaoActions } from "../../store/ducks/application/remocao/remocao";
import { MxNavigationBarActions } from "../../store/ducks/components/NavigationBar/navigationBar";
import { DetalheCarregaGateActions } from "../../store/ducks/application/CarregaDescarregaContainer/detalheCarregaGate";
import { DetalheDescarregaGateActions } from "../../store/ducks/application/CarregaDescarregaContainer/detalheDescarregaGate";
import { ControleReeferActions } from "../../store/ducks/application/controleReefer/controleReefer";
import { ConsultasGeraisActions } from "../../store/ducks/application/ConsultasGerais/consultasGerais";
import { ArmazemGeralActions } from "../../store/ducks/application/ArmazemGeral/armazemGeral";
import { useArmazemGeral } from "../../store/ducks/application/ArmazemGeral/useArmazemGeral";
import { useCarregaDescarregaVolumeMercadoria } from "../../store/ducks/application/CarregaDecarregaVolumeMercadoria/useCarregaDescarregaVolumeMercadoria";
import { useDesova } from "../../store/ducks/application/Desova/useDesova";
import NomeDasRotas from "./data/nomeRotas.json";
import {
    useTypedSelector,
    useUpdateOnGoBack,
    useUpdateOnGoHome,
    useUpdateOnMinimizar
} from "../../hooks";
import { persistor } from "../../store";
import { useQueryClient } from "react-query";
import { SolServActions } from "../../store/ducks/application/SolServ/SolServ";
import { OperacaoContainerActions } from "../../store/ducks/application/OperacaoContainer/OperacaoContainer";
import { useAplicativo } from "../../store/ducks/application/Aplicativo/useAplicativo";
import { AplicativoReducerActions } from "../../store/ducks/application/Aplicativo/Aplicativo";
import { ContentPaste, DocumentScanner, Folder, FolderOpen, Image, InsertDriveFile } from "@mui/icons-material";
import { ListItem } from "@mui/material";
import { CarregamentoPosDescargaActions } from "../../store/ducks/application/CarregaDescarregaContainer/carregamentoPosDescarga";
import { AvisoVersao } from "../Login";
import { DesovaActions } from "../../store/ducks/application/Desova/desova";

const NavigationBar = props => {
    const dispatch = useDispatch();

    const stateLogin = useTypedSelector(state => state.loginreducer);
    const stateNavigationBar = useTypedSelector(
        state => state.navigationBarreducer
    );
    const detalheDescarregaGateReducer = useTypedSelector(state => state.detalheDescarregaGateReducer);

    const statePesquisa = useTypedSelector(state => state.pesquisaReducer);

    const cdvmReducer = useCarregaDescarregaVolumeMercadoria();
    const armazemGeral = useArmazemGeral();
    const desovaReducer = useDesova();
    const aplicativoReducer = useAplicativo();

    const objectToken = MxUtils.getObjectToken(stateLogin.Token);

    let appsMinimized = stateNavigationBar.Aplicativos;

    const history = useHistory();

    const classes = useStyles();
    const [isOpen, setIsOpen] = useState(false);
    const [isDocumentoMenuOpen, setDocumentoMenuOpen] = useState(true);
    const [isPsoOpen, setIsPsoOpen] = useState(true);

    const [backColor, setBackColor] = useState(
        MxUtils.validarAmbienteProducao() ? "#004aad" : "green"
    );
    const queryClient = useQueryClient();

    const grupoDoApp =
        Object.values(NomeDasRotas).find(grupo =>
            grupo.includes(props.title)
        ) ?? [];

    const nomeAppAtual = history.location.pathname
        .split("/")[1]
        .replace("/", "")
        .toLowerCase();

    const Logout = () => {
        MxUtils.limparStorageLogin();

        queryClient.clear();
        sessionStorage.clear();
        history.push("/");
        persistor.purge();
    };

    const getDocumentos = () => {
        let reqContext = require
            .context('../../assets/documents', false, /\.(png|jpe?g|svg|jpg|pdf)$/);

        return reqContext
            .keys()
            .map((item, i) => {
                return {
                    nome: item.substring(2, item.lastIndexOf('.')),
                    caminho: reqContext(item).default,
                    extensao: item.substring(item.lastIndexOf('.'), item.length)
                }
            })
    }

    const getPso = () => {
        let reqContext = require
            .context('../../assets/pso', false, /\.(png|jpe?g|svg|jpg|pdf)$/);

        return reqContext
            .keys()
            .map((item, i) => {
                return {
                    nome: item.substring(2, item.lastIndexOf('.')),
                    caminho: reqContext(item).default,
                    extensao: item.substring(item.lastIndexOf('.'), item.length)
                }
            })
    }

    const toggleDrawer = (open, event) => {
        if (
            event.type === "keydown" &&
            (event.key === "Tab" || event.key === "Shift")
        ) {
            return;
        }
        setIsOpen(open);
    };
    const handleDesminimizarApp = () => {
        let arrMinimized = appsMinimized.filter(
            app =>
                !(
                    grupoDoApp.includes(app.NomeApp) ||
                    app.NomeApp === nomeAppAtual
                )
        );
        dispatch(MxNavigationBarActions.minimize(arrMinimized));
    };

    /**
     * @description Trata o evento de voltar da barra de navegação
     *
     * *Default* - `history.goBack()`
     *
     * **IMPORTANTE** Para alterar a funcionalidade deste método, utilize o hook {@link useUpdateOnGoBack}
     *
     * @example
     * ```javascript
     * Componente(props) => {
     * ...
     * useUpdateOnGoBack(() => {
     * 	return funcaoDeCleanUp()
     * },
     *  {
     * 	limparAposUso: true,
     *  })
     * ...
     * }
     * ```
     */
    const goBack = () => {
        handleDesminimizarApp();
        if (stateNavigationBar.onGoBack) {
            stateNavigationBar.onGoBack();
            return;
        }

        if (props.match.url === "/ListagemAplicativos" && !!aplicativoReducer.state?.agrupador?.PaiId) {
            dispatch(AplicativoReducerActions.setAgrupador({ Id: aplicativoReducer.state?.agrupador?.PaiId }));
            return;
        }

        switch (props.title) {
            case "Carrega Descarrega Volume Mercadoria":
            case "Operações de Pátio":
            case "Controle Reefer":
            case "Armazém Geral":
            case "Coletor Desova - Containers":
            case "Sol Serv Desova":
            case "Remontagem Volume":
                handleDesminimizarApp();
                history.push("/ListagemAplicativos");
                break;

            case "Lacres":
            case "Avarias":
            case "Avarias OEA":
                history.push("/CarregaDescarregaContainer/Vistoria");
                break;

            case "Carrega Gate":
                history.push("/CarregaDescarregaContainer/DetalheCarregaGate");
                break;

            case "Descarrega Gate":
            case "Carregamento Pós Descarga":
                history.push(
                    "/CarregaDescarregaContainer/DetalheDescarregaGate"
                );
                break;

            case "Remoção":
            case "Descarga de Veículo":
            case "Autorizar Entrada":
            case "Detalhes do Gate":
            case "Carregamento de Veículo":
                history.push("/CarregaDescarregaContainer/ListaGate");
                break;

            case "Vistoria":
                if (detalheDescarregaGateReducer.retornaTelaDetalhes)
                    history.push("/CarregaDescarregaContainer/DetalheDescarregaGate");
                else
                    history.push("/CarregaDescarregaContainer/ListaGate");
                break;

            case "Carrega Volume Mercadoria":
            case "Descarrega Volume Mercadoria":
                history.push("/CarregaDescarregaVolumeMercadoria/ListaOperacoes");
                break;

            case "Carrega Volume Mercadoria - Detalhe":
            case "Carrega Volume Mercadoria - Recursos":
                history.push("/CarregaDescarregaVolumeMercadoria/Carregamento");
                break;

            case "Carrega Volume Mercadoria - Carregar":
                if (cdvmReducer.state.carregamento.tipo === 35)
                    history.push("/CarregaDescarregaVolumeMercadoria/Carregamento/Detalhe");
                if (cdvmReducer.state.carregamento.tipo !== 'armazemGeral')
                    history.push("/CarregaDescarregaVolumeMercadoria/Carregamento");
                break;

            case "Carrega Volume Mercadoria - Checklist Peação":
                if (cdvmReducer.state.telaPeacao.carregamento === true)
                    history.push({ pathname: "/CarregaDescarregaVolumeMercadoria/ListaOperacoes" })
                else
                    history.push({ pathname: "/CarregaDescarregaVolumeMercadoria/Carregamento" })
                break;

            case "Carrega Volume Mercadoria - DDC":
                history.push("/CarregaDescarregaVolumeMercadoria/Carregamento");
                break;

            case "Carrega Volume Mercadoria - DDC - Desovar":
            case "Carrega Volume Mercadoria - DDC - Acrescimo":
            case "Carrega Volume Mercadoria - DDC - Finalizar Desova":
                history.push("/CarregaDescarregaVolumeMercadoria/Desovando");
                break;

            case "Carrega Volume Mercadoria - DDC - Avarias Volume":
                history.push("/CarregaDescarregaVolumeMercadoria/Desovar")
                break;

            case "Carrega Volume Mercadoria - DDC - Finalizar Desova - Avaria":
                history.push("/CarregaDescarregaVolumeMercadoria/FinalizarDesova")
                break;

            case "Descarrega Volume Mercadoria - Descarregar":
            case "Descarrega Volume Mercadoria - Reconhecimento":
            case "Descarrega Volume Mercadoria - Recursos":
                history.push("/CarregaDescarregaVolumeMercadoria/Descarga");
                break;

            case "Descarrega Volume Mercadoria - Avaria":
                history.push("/CarregaDescarregaVolumeMercadoria/Descarga/Descarregar");
                break;

            case "Registrar Leitura":
            case "Leituras Pendentes":
                history.push("/Reefer/ConsultaContainer");
                break;

            case "Posicionar":
            case "Pickup":
                history.push("/remocao/");
                break;

            case "Remontagem de Mercadorias":
            case "Reconhecimento de Itens":
            case "Posicionamento de Vol.":
            case "Baixa de Documento":
                history.push("/ArmazemGeral");
                break;
            case "Remontagem Armazém Geral": {
                verificaEtapaRemontagem(armazemGeral.state.etapa);
                break;
            }

            //Coletor SolServ Estufagem
            case "Sol Serv": {
                dispatch(SolServActions.resetStateSolServ());
                history.push("/ListagemAplicativos");
                break;
            }
            case "Sol Serv - Itens Estufagem":
            case "Sol Serv - Desovando":
                dispatch(SolServActions.resetStateSolServLacres());
                dispatch(SolServActions.resetStateSolServPeacao());
                history.push("/SolServ");
                break;
            case "Sol Serv - Volume":
                dispatch(SolServActions.resetVolumePesquisado());
                history.push("/SolServ/SolServItensEstufagem");
                break;
            case "Sol Serv - Interromper Estufagem":
                dispatch(SolServActions.resetStateSolServLacres());
                dispatch(SolServActions.resetStateSolServPeacao());
                history.push("/SolServ/SolServItensEstufagem");
                break;
            case "Sol Serv - Finalizar Estufagem":
                history.push("/SolServ/SolServItensEstufagem");
                break;
            case "Sol Serv - Recursos":
                history.push("/SolServ/FinalizarSolServEstufagem");
                break;
            case "Sol Serv - Desova":
            case "Sol Serv - Desova - Finalizar Desova":
            case "Sol Serv - Desovando - Acrescimo":
                history.push("/SolServ/SolServDesovando");
                break;
            case "Sol Serv - Desova - Avarias Volume":
                history.push("/SolServ/SolServDesovar");
                break;
            case "Sol Serv - Desova - Avarias Container":
                history.push("/SolServ/SolServFinalizarDesova");
                break;

            // ColetorDesova
            case "Coletor Desova - Desovar":
                if (desovaReducer.state.reconhecimento)
                    history.push("/ColetorDesova");
                else
                    history.push("/ColetorDesova/Desovando");
                break;
            case "Coletor Desova - Desovando":
            case "Coletor Desova - Iniciar Desova":
                history.push("/ColetorDesova");
                break;
            case "Coletor Desova - Finalizar Desova":
            case "Coletor Desova - Informações Siscomex":
            case "Coletor Desova - Detalhes Volume":
            case "Coletor Desova - Interromper Desova":
                history.push("/ColetorDesova/Desovando");
                break;
            case "Coletor Desova - Avarias Volume":
                history.push("/ColetorDesova/Desovar");
                break;
            case "Coletor Desova - Avarias Container":
            case "Coletor Desova - Peação":
                history.push("/ColetorDesova/FinalizarDesova");
                break;

            case "Itens Estufagem":
                dispatch(SolServActions.resetVolumePesquisado());
                history.push("/SolServ");
                break;
            case "Volume":
                history.push("/SolServItensEstufagem");
                break;
            case "Interromper Estufagem":
                history.push("/SolServ");
                break;

            //Sol Serv Desova
            case "Sol Serv Desova - Container":
                history.push("/SolServDesova");
                break;

            case "Sol Serv Desova - Interromper":
            case "Sol Serv Desova - Desovar Volume":
            case "Sol Serv Desova - Reconhecimento Volume":
            case "Sol Serv Desova - Finalizar Desova":
                history.push("/SolServDesova/DetalhesContainer");
                break;

            case "Sol Serv Desova - Reconhecer Volume":
                history.push("/SolServDesova/ReconhecimentoVolume");
                break;

            case "Remontagem Volume - Remontar":
                history.push("/RemontagemVolume");
                break;

            case "Imagens em Geral": {
                history.push("/ImagensApp");
                break;
            }

            case "Confere": {
                history.push("/ImagensApp");
                break;
            }

            case "Consulta - Container": {
                if (statePesquisa.destino === 'confere')
                    history.push("/Confere");

                if (statePesquisa.destino === 'geral')
                    history.push("/ImagensEmGeral");

                break;
            }

            case "Consulta - Volume": {
                if (statePesquisa.destino === 'confere')
                    history.push("/Confere");

                if (statePesquisa.destino === 'geral')
                    history.push("/ImagensEmGeral");

                break;
            }

            case "Consulta - Etiqueta": {
                if (statePesquisa.destino === 'confere')
                    history.push("/Confere");

                if (statePesquisa.destino === 'geral')
                    history.push("/ImagensEmGeral");

                break;
            }

            case "Confirmar Imagem": {
                if (statePesquisa.destino === 'confere')
                    history.push("/Confere");

                if (statePesquisa.destino === 'geral')
                    history.push("/ImagensEmGeral");

                break;
            }

            case "ImagensApp": {
                history.push("/ListagemAplicativos");
                break;
            }

            default:
                history.goBack();
                break;
        }
    };

    function verificaEtapaRemontagem(etapa) {
        if (etapa === 2) {
            dispatch(armazemGeral.actions.atualizarEtapa(1));
            return;
        }

        if (etapa === 3) {
            dispatch(armazemGeral.actions.atualizarEtapa(2));
            return;
        }

        if (etapa === 4) {
            dispatch(armazemGeral.actions.atualizarEtapa(3));
            return;
        }

        if (etapa === 5) {
            dispatch(armazemGeral.actions.atualizarEtapa(4));
            return;
        }

        if (etapa === 6) {
            dispatch(armazemGeral.actions.atualizarEtapa(5));
            return;
        }

        history.push("/ArmazemGeral");
    }

    let Terminal = MxUtils.getTerminalPorID(stateLogin.Terminal);

    /**
     * @description Trata o evento de clicar na opção NÃO após abrir o alerta de confirmação de minimizar.
     *
     * *Default*: Volta pra tela de listagem de aplicativos sem minimizar o app atual.
     *
     * **IMPORTANTE** Para alterar a funcionalidade deste método, utilize o hook {@link useUpdateOnGoHome}
     *
     * @example
     * ```javascript
     * Componente(props) => {
     * ...
     *  useUpdateOnGoHome(() => {
     * 	funcaoDeCleanUp()

     * 	})
     * ...
     * }
     * ```
     */

    async function naoClick() {
        dispatch(MxAlertaActions.ExecutarClose());
        dispatch(MxNavigationBarActions.resetOnGoBack());
        handleDesminimizarApp();

        if (stateNavigationBar.onVoltarHome) {
            stateNavigationBar.onVoltarHome();
        } else {
            if (!MxUtils.validarAmbienteProducao()) {
                console.warn(
                    "Não foi passada nenhuma função de cleanup para stateNavigationBar.onVoltarHome. Certifique-se de que esta é uma rota legada ou então passe uma função de cleanup com dispatch(MxNavigationBarActions.onVoltarHome(cleanupCB))."
                );
            }

            Object.entries(NomeDasRotas).forEach(([key, value]) => {
                if (value.includes(props.title)) {
                    switch (key) {
                        case "grupoCarrDesc":
                            switch (props.title) {
                                case "Operações de Pátio":
                                case "Vistoria":
                                case "Avarias":
                                case "Avarias OEA":
                                    dispatch(VistoriaActions.resetState());
                                    break;

                                case "Autorizar Entrada":
                                    break;

                                case "Lacres":
                                    dispatch(LacresActions.resetLacresState());
                                    dispatch(VistoriaActions.resetState());
                                    break;

                                case "Remoção":
                                    dispatch(
                                        RemocaoActions.resetRemocaoState()
                                    );
                                    break;

                                case "Interrupção":
                                case "Carregamento de Veículo":
                                case "Detalhes do Gate":
                                case "Carrega Gate":
                                    dispatch(
                                        DetalheCarregaGateActions.resetStateDetalheCarrega()
                                    );
                                    break;

                                case "Descarga de Veículo":
                                case "Descarrega Gate":
                                    dispatch(
                                        DetalheDescarregaGateActions.resetStateDetalheDescarrega()
                                    );
                                    break;

                                case "Pickup":
                                case "Posicionar":
                                    dispatch(
                                        RemocaoActions.resetRemocaoState()
                                    );
                                    break;
                                default:
                                    break;
                            }
                            break;
                        case "grupoReefer":
                            dispatch(
                                ConsultasGeraisActions.resetStateConsultasGerais()
                            );
                            break;
                        case "grupoTurno":
                            break;
                        case "grupoConsultasGerais":
                            dispatch(
                                ConsultasGeraisActions.resetStateConsultasGerais()
                            );
                            break;
                        case "grupoArmazemGeral":
                            dispatch(ArmazemGeralActions.resetarRemontagem());
                            break;
                        case "grupoSolServEstufagem":
                            dispatch(SolServActions.resetStateSolServ());
                            break;
                        case "grupoOperacaoContainer":
                            dispatch(OperacaoContainerActions.resetContainer());
                            break;
                        case "grupoCarregamentoPosDescarga":
                            dispatch(CarregamentoPosDescargaActions.resetCarregamentoPosDescarga());
                            break;
                        case "grupoDesova":
                            dispatch(DesovaActions.resetAcrescimo());
                            dispatch(DesovaActions.resetAvarias());
                            dispatch(DesovaActions.resetDesova());
                            dispatch(DesovaActions.resetFinalizarDesova());
                            break;
                        default:
                            console.warn("Não foi encontrado o grupo do app");
                            break;
                    }
                }
            });
        }

        history.push("/ListagemAplicativos");
    }

    /**
     * @description Trata o evento de clicar na opção SIM após abrir o alerta de confirmação de minimizar.
     *
     * *Default*: Volta pra tela de listagem de aplicativos minimizando o app.
     *
     * **IMPORTANTE** Para alterar a funcionalidade deste método, utilize o hook {@link useUpdateOnMinimizar}
     *
     * @example
     * ```javascript
     * Componente(props) => {
     * ...
     *  useUpdateOnMinimizar(() => {
     * 	funcaoDeSalvarEstado()
     * 	return ({
     *  		preventDefault: false
     * 		})
     * 	})
     * ...
     * }
     * ```
     */
    async function simClick() {
        dispatch(MxAlertaActions.ExecutarClose());
        if (stateNavigationBar.onMinimizar) {
            const options = Object.assign(
                {},
                {
                    preventDefault: false
                },
                stateNavigationBar.onMinimizar() ?? {}
            );

            if (options.preventDefault instanceof Function)
                return options.preventDefault();

            if (options.preventDefault) return naoClick();
        }

        const rotaAtual = history.location.pathname.replace(/^\//, ""); //Remove o prefixo "/" da rota
        let rota = history.location.pathname;

        let arrMinimized = appsMinimized.filter(
            app =>
                !(
                    grupoDoApp.includes(app.NomeApp) ||
                    app.NomeApp === nomeAppAtual
                )
        );
        arrMinimized.push({ NomeApp: nomeAppAtual, Rota: rota });

        dispatch(MxNavigationBarActions.minimize(arrMinimized));

        history.push("/ListagemAplicativos");
    }

    const [clickCount, setClickCount] = useState(0);
    const timerRef = useRef(null);

    const handleClick = () => {
        setClickCount(prev => prev + 1);

        // Limpa o timer anterior
        if (timerRef.current) {
            clearTimeout(timerRef.current);
        }

        // Espera 500ms para resetar o contador
        timerRef.current = setTimeout(() => {
            if (clickCount >= 3) {
                dispatch(MxAlertaActions.ExecutarAlertaComConfirmacao('Sobre', <AvisoVersao showIndexedDBInfo={true} />, () => { dispatch(MxAlertaActions.ExecutarClose()) }, 'Ok'));
            }
            setClickCount(0);
        }, 500); // Ajuste esse valor para maior ou menor sensibilidade
    };

    return (
        <div>
            <div className={classes.root}>
                <AppBar
                    position="static"
                    style={{ background: backColor }}
                    onClick={handleClick}
                >
                    <Toolbar>
                        {props.mostraBotaoMenu ? (
                            <IconButton
                                edge="start"
                                className={classes.menuButton}
                                color="inherit"
                                aria-label="menu"
                                onClick={e => {

                                    toggleDrawer(true, e);
                                }}
                            >
                                <MenuIcon />
                            </IconButton>
                        ) : (
                            <IconButton
                                edge="start"
                                className={classes.menuButton}
                                color="inherit"
                                aria-label="menu"
                                onClick={() => {
                                    goBack();
                                }}
                            >
                                <ArrowBackIcon />
                            </IconButton>
                        )}
                        <Typography
                            component="h1"
                            variant="h6"
                            className={classes.title}
                        >
                            {props.title}
                        </Typography>

                        {props.mostraBotaoHome ? (
                            <IconButton
                                aria-label=""
                                edge="end"
                                color="inherit"
                                onClick={() => {
                                    //history.push('/ListagemAplicativos');

                                    // A tela pode barrar a saída (ex.: imagens
                                    // pendentes de envio). Checado antes de
                                    // limpar o storage e de abrir o alerta.
                                    if (
                                        stateNavigationBar.onTentarSair &&
                                        stateNavigationBar.onTentarSair() === false
                                    )
                                        return;

                                    // ? Qual o propósito disso?
                                    MxUtils.limparSessionStorage();

                                    if (props.title !== "Bem vindo") {
                                        dispatch(
                                            MxAlertaActions.ExecutarConfirm(
                                                "Minimizar",
                                                "Deseja minimizar o aplicativo " +
                                                props.title +
                                                "?",
                                                simClick,
                                                naoClick,
                                                true
                                            )
                                        );
                                    }
                                }}
                            >
                                <Home />
                            </IconButton>
                        ) : (
                            <></>
                        )}
                    </Toolbar>
                </AppBar>
            </div>
            <Drawer
                classes={{ paper: classes.drawer }}
                open={isOpen}
                onClose={e => {
                    toggleDrawer(false, e);
                }}
            >
                <div
                    className={classes.fullList}
                    role="presentation"
                >
                    <div className={classes.infoUsuario}>
                        <Box
                            display="flex"
                            mt={3}
                            // bgcolor="lightgreen"
                            alignItems="center"
                            justifyContent="center"
                        //fontWeight="bold"
                        >
                            {objectToken?.nome || ""}
                        </Box>

                        <Box
                            display="flex"
                            mt={1}
                            // bgcolor="lightgreen"
                            alignItems="center"
                            justifyContent="center"
                        //fontWeight="bold"
                        >
                            {Terminal}
                        </Box>
                    </div>

                    {props.mostraraplicativos ? <Fragment>
                        {/* <Divider />
              <MenuList>
                {RoutesMenu.map((prop, key) => {
                  return (
                    <NavLink to={prop.path} style={{ textDecoration: 'none' }} key={key}>
                      <MenuItem selected={activeRoute(prop.path)}>
                        <ListItemText primary={prop.sidebarName} />
                      </MenuItem>
                    </NavLink>
                  );
                })}
              </MenuList> */}
                    </Fragment> : null}
                    <Divider />
                    <MenuList dense>
                        <MenuItem onClick={() => { setDocumentoMenuOpen(!isDocumentoMenuOpen) }}>
                            <FolderOpen />
                            <ListItemText>Documentos</ListItemText>
                            {isDocumentoMenuOpen ? <ExpandLess /> : <ExpandMore />}
                        </MenuItem>
                        <Collapse in={isDocumentoMenuOpen}>
                            {
                                getDocumentos()
                                    .map(o =>
                                        <MenuItem key={o.nome} onClick={() => window.open(o.caminho)} style={{ marginLeft: '15px' }}>
                                            <Image /><ListItemText>{o.nome}</ListItemText>
                                        </MenuItem>
                                    )
                            }
                        </Collapse>
                        <MenuItem onClick={() => { setIsPsoOpen(!isPsoOpen) }}>
                            <ContentPaste />
                            <ListItemText>PSO</ListItemText>
                            {isPsoOpen ? <ExpandLess /> : <ExpandMore />}
                        </MenuItem>
                        <Collapse in={isPsoOpen}>
                            {
                                getPso()
                                    .map(o =>
                                        <MenuItem key={o.nome} onClick={() => window.open(o.caminho)} style={{ marginLeft: '15px' }}>
                                            <InsertDriveFile /><ListItemText>{o.nome}</ListItemText>
                                        </MenuItem>
                                    )
                            }
                        </Collapse>
                        <Divider />
                        <NavLink to="/" style={{ textDecoration: "none" }}>
                            <MenuItem>
                                <ExitToAppIcon />
                                <ListItemText
                                    primary="Logout"
                                    onClick={() => {
                                        Logout();
                                    }}
                                />
                            </MenuItem>
                        </NavLink>
                    </MenuList>
                </div>
            </Drawer>
        </div>
    );
};

export default withRouter(NavigationBar);
